import { Routes } from '@angular/router';
import { adminGuard, authGuard, guestGuard, homeRouteGuard } from 'guards/auth.guard';
import { verticalBreadcrumbGuard, verticalCanMatch } from 'guards/vertical.guard';
import { legacyContractsRedirect } from 'pages/products/contracts/legacy-redirects';

export const routes: Routes = [
	{
		path: 'auth',
		loadComponent: () => import('components/layouts/clear.layout').then((m) => m.ClearLayout),
		loadChildren: () => import('pages/auth/auth.routes').then((m) => m.AUTH_ROUTES),
	},
	{
		path: 'welcome',
		loadComponent: () => import('components/layouts/clear.layout').then((m) => m.ClearLayout),
		children: [
			{
				path: '',
				title: 'Bem-vindo ao HUB',
				canActivate: [guestGuard],
				loadComponent: () => import('pages/auth/welcome/welcome').then((m) => m.WelcomePage),
			},
		],
	},
	{
		path: 'portal',
		loadComponent: () => import('components/layouts/clear.layout').then((m) => m.ClearLayout),
		loadChildren: () =>
			import('pages/external-portal/external-portal.routes').then((m) => m.PORTAL_ROUTES),
	},
	{
		path: '',
		canActivate: [authGuard],
		loadComponent: () => import('components/layouts/app.layout').then((m) => m.AppLayout),
		children: [
			{
				path: '',
				data: { breadcrumb: 'Início' },
				children: [
					{
						path: '',
						title: 'Início',
						canActivate: [homeRouteGuard],
						loadComponent: () => import('pages/home/home').then((m) => m.HomePage),
					},
					{
						path: 'home/clean',
						title: 'Clean Funcional',
						data: { breadcrumb: 'Clean Funcional' },
						canActivate: [homeRouteGuard],
						loadComponent: () =>
							import('pages/home/variants/clean-funcional').then((m) => m.CleanFuncionalPage),
					},
					{
						path: 'home/command',
						title: 'Command Center',
						data: { breadcrumb: 'Command Center' },
						canActivate: [homeRouteGuard],
						loadComponent: () =>
							import('pages/home/variants/command-center').then((m) => m.CommandCenterPage),
					},
					{
						path: 'home/corporate',
						title: 'Corporate Premium',
						data: { breadcrumb: 'Corporate Premium' },
						canActivate: [homeRouteGuard],
						loadComponent: () =>
							import('pages/home/variants/corporate-premium').then((m) => m.CorporatePremiumPage),
					},
					{
						// Configurações do Hub (Perfil, Segurança, Preferências) — auth mockado em modules/auth
						path: 'settings',
						loadChildren: () =>
							import('pages/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
					},
					{
						// URLs do roteiro do cliente (/products/contratos/**) → mesma tradução de /:vertical/contratos
						path: 'products/contratos',
						children: [
							{ path: '', pathMatch: 'full', redirectTo: legacyContractsRedirect },
							{ path: '**', redirectTo: legacyContractsRedirect },
						],
					},
					// Produtos por vertical, como no Hub: /trabalhista/contestacao, /tributario/contracts…
					{
						path: ':verticalSlug',
						canMatch: [verticalCanMatch],
						canActivate: [verticalBreadcrumbGuard],
						loadChildren: () =>
							import('pages/products/products.routes').then((m) => m.PRODUCTS_ROUTES),
					},
				],
			},
			{
				path: 'admin',
				title: 'Admin',
				canActivate: [adminGuard],
				loadChildren: () => import('pages/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
			},
			{
				path: '**',
				title: 'Página não encontrada',
				loadComponent: () => import('pages/errors/not-found').then((m) => m.NotFoundPage),
			},
		],
	},
];
